'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';

interface RenderGoogleTagScriptCustomProps {
	id: string;
	domain: string;
}

const RenderGoogleTagScriptCustom = ({ id, domain }: RenderGoogleTagScriptCustomProps) => {
	const [shouldRender, setShouldRender] = useState(false);

	useEffect(() => {
		if (typeof window !== 'undefined' && window.location.hostname === domain) {
			setShouldRender(true);
		}
	}, [domain]);

	if (!shouldRender) {
		return null;
	}

	return (
		<>
			<Script id={`gtag-${id}`} src={`https://www.googletagmanager.com/gtag/js?id=${id}`} strategy="afterInteractive" />
			<Script
				id={`gtag-config-${id}`}
				strategy="afterInteractive"
				dangerouslySetInnerHTML={{
					__html: `
						window.dataLayer = window.dataLayer || [];
						function gtag(){dataLayer.push(arguments);}
						gtag('js', new Date());
						gtag('config', '${id}');
					`
				}}
			/>
		</>
	);
};

export default RenderGoogleTagScriptCustom;
